import styled from '@emotion/styled';

export const StyledBox = styled('div', {})({
  display: 'flex',
  width: '100%',
  minHeight: 500,

  justifyContent: 'center',
  alignItems: 'center',
});
